module.exports = __webpack_public_path__ + "static/media/instructions.cf3339c2.pdf";